import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "Util/refluxConnector";
import { translate as _l } from "oxygen-i18n";
import { Units } from "Css";
import { List, Toggle } from "material-ui";
import CourseActions from "actions/Course";
import CourseStore from "stores/Course";
import debounce from "oxygen-debounce";
import { getDelayedAccessSettings } from "selectors/dripContent.selector";
import PeriodSelector from "components/PeriodSelector";

addTranslations({
  ["en-US"]: {
    "Drip content": "Drip content",
    "Enable drip content": "Enable drip content",
    "Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.":
      "Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.",
    "Please decide per section when they should become available after the user purchases or gains access to the course.":
      "Please decide per section when they should become available after the user purchases or gains access to the course.",
    "Enable gated access": "Enable gated access",
    "Enable delayed access": "Enable delayed access"
  },
  ["sv-SE"]: {
    "Drip content": "Drip content",
    "Enable drip content": "Aktivera drip content",
    "Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.":
      "Användare kan bara öppna en sida om de redan klarat av föregående sida. Detta säkerställer att dina användare genomgår kursen på ett naturligt sätt.",
    "Please decide per section when they should become available after the user purchases or gains access to the course.":
      "Vänligen bestäm varje avsnitt när de ska bli tillgängliga efter att användaren har köpt eller får tillgång till kursen.",
    "Enable gated access": "Aktivera blockerad tillgång",
    "Enable delayed access": "Aktivera fördröjd åtkomst"
  }
});

const styles = {
  list: {
    paddingTop: 32,
    backgroundColor: "#FFFFFF"
  },
  listHeader: {
    fontSize: 24,
    borderStyle: "none none solid none",
    borderWidth: "1px",
    borderColor: "rgba(0, 0, 0, 0.12)"
  }
};

const css = oxygenCss({
  header: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: 24,
    fontWeight: 500,
    lineHeight: "48px",
    paddingLeft: 16,
    borderStyle: "none none solid none",
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.12)"
  },
  content: {
    padding: 16
  },
  buttonWrapper: {
    padding: 16
  },
  panel: {
    textAlign: "center",
    padding: Units.keyline / 2
  },
  info: {
    padding: 16,
    // fontSize: 18,
    fontStyle: "oblique",
    borderRadius: 3,
    border: "solid 1px rgba(0, 0, 0, 0.1)",
    backgroundColor: "rgba(42, 232, 191, 0.1)"
  }
});

class CourseDripContentEditor extends Component {
  static propTypes = {
    children: PropTypes.node,
    course: PropTypes.object,
    save: PropTypes.func,
    update: PropTypes.func,
    updateSection: PropTypes.func,
    delayedAccessSettings: PropTypes.array
  };

  constructor(props) {
    super(props);
    const { course = {}, delayedAccessSettings } = this.props;
    const toc = props.course.toc;
    const settings = course.settings || {};
    const dripContent = settings.dripContent || {};
    const { gatedAccess, delayedAccess } = dripContent;
    const synchronizedDelayedAccessSettings = [];
    const map = new Map();
    for (const item of toc.concat(delayedAccessSettings)) {
      if (!map.has(item.id)) {
        map.set(item.id, true);
        synchronizedDelayedAccessSettings.push({
          id: item.id,
          name: item.name,
          accessDelay: item.accessDelay || null
        });
      }
    }
    
    this.state = {
      gatedAccess: gatedAccess || null,
      delayedAccess: delayedAccess || null,
      delayedAccessSettings:synchronizedDelayedAccessSettings
    };
  }

  save = debounce(() => {
    const { save } = this.props;
    save();
  }, 300);

  toggleAccess = data => {
    const { update } = this.props;
    this.setState(data);
    update(data);
    this.save();
  };

  handleDelayedAccessChange = (sectionId, accessDelay) => {
    const { updateSection } = this.props;
    updateSection({ id: sectionId, accessDelay });
  };

  render() {
    return (
      <List
        subheader={_l`Drip content`}
        style={styles.list}
        subheaderStyle={styles.listHeader}
      >
        <div className={css.buttonWrapper}>
          <Toggle
            checked={this.state.gatedAccess}
            label={_l`Enable gated access`}
            onToggle={(event, toggled) =>
              this.toggleAccess({ gatedAccess: toggled })
            }
          />
          {this.state.gatedAccess && (
            <div className={css.info}>
              {_l`Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.`}
            </div>
          )}
        </div>
        <div className={css.buttonWrapper}>
          <Toggle
            checked={this.state.delayedAccess}
            label={_l`Enable delayed access`}
            onToggle={(event, toggled) =>
              this.toggleAccess({ delayedAccess: toggled })
            }
          />
          {this.state.delayedAccess && (
            <div>
              <div className={css.info}>
                {_l`Please decide per section when they should become available after the user purchases or gains access to the course.`}
              </div>
              <List>
                {this.state.delayedAccessSettings.map(section => {
                  return (
                    <PeriodSelector
                      value={section.accessDelay}
                      key={section.id}
                      onChange={seconds =>
                        this.handleDelayedAccessChange(section.id, seconds)
                      }
                    >
                      {section.name}
                    </PeriodSelector>
                  );
                })}
              </List>
            </div>
          )}
        </div>
      </List>
    );
  }
}



export default connect(
  [
    [
      CourseStore,
      state => ({
        delayedAccessSettings: getDelayedAccessSettings(state)
      })
    ]
  ],
  {
    updateSection: CourseActions.updateSection,
    update: CourseActions.updateDripContent,
    save: CourseActions.saveSettings
  }
)(CourseDripContentEditor);



// WEBPACK FOOTER //
// ./src/js/containers/CourseDripContentEditor.js